module.exports = __webpack_public_path__ + "static/media/slider-gif4.d121f329.gif";